import type { LoaderFunctionArgs } from "react-router";
import server from "../server";
import type { Campaign } from "../type";

export type CampaignLoaderData = {
  campaign: Campaign | null;
  campaignError: string | null;
  companyParam: string | null;
};

export async function campaignLoader({
  params,
}: LoaderFunctionArgs): Promise<CampaignLoaderData> {
  const companyParam = params.company ?? null;

  if (!companyParam) {
    return {
      campaign: null,
      campaignError: "Missing company param",
      companyParam: null,
    };
  }

  try {
    const now = new Date().toISOString();
    const response = await server.findAll("campaigns", {
      populate: {
        banner_web: true,
        banner_mobile: true,
        logo: true,
        setmenus: { populate: "*" },
      },
      filters: {
        active: true,
        path: companyParam,
        start_date: { $lte: now },
        end_date: { $gte: now },
      },
    });

    return {
      campaign: response?.[0] ?? null,
      campaignError: null,
      companyParam,
    };
  } catch (error) {
    console.error("Failed to fetch campaign:", error);
    return {
      campaign: null,
      campaignError: "Failed to load campaign",
      companyParam,
    };
  }
}